export const MODEL_ROUTE = '/software';
